import { Redis } from '@upstash/redis';
import { DateTime } from 'luxon';

const redis = new Redis({
    url: process.env.REDIS_PRIMARY_URL,
    token: process.env.REDIS_PRIMARY_TOKEN,
});

const getToday = () =>
    DateTime.fromMillis(Date.now()).toFormat('yyyy-MM-dd');

export const addShells = async (shells: number) => {
    if (shells <= 0) return;

    const today = getToday();

    try {
        const newShells = await redis.incrby(`shells:${today}`, shells);
        return newShells;
    } catch (error) {
        console.error('Error adding shells:', error);
    }
};